<script>
import { connect } from 'vuex-connect';
import CountdownWithLabel from '@/launcher/components/shared/CountdownWithLabel.vue';

export default connect({
  gettersToProps: {
    remainingTime: 'remainingTime',
    status: 'timerStatus',
    station: 'currentStation',
  },
  lifecycle: {

  },
})('CountdownWithLabel', CountdownWithLabel);
</script>
